import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useParams, useNavigate } from "react-router-dom";

import { useUiFeedback } from "../../../context/ui-feedback/ui-feedback";
import {
  createWaiting,
  closeWaiting,
  createErrorFeedback,
} from "../../../context/ui-feedback/action";
import { useLoadTemplateById } from "../../../api/templates-api";
import { TemplateEditor } from "./component/template-editor";
import { PageLayout } from "../../common/page-layout/page-layout";

export const EditTemplate = () => {
  const { id } = useParams();
  const intl = useIntl();
  const navigate = useNavigate();
  const loadTemplateById = useLoadTemplateById();

  const { uiFeedbackDispatch } = useUiFeedback();

  const localTemplateId = useRef(null);
  const [reload, setReload] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState(null);

  useEffect(() => {
    const loadTemplate = async () => {
      createWaiting(uiFeedbackDispatch);
      setCurrentTemplate(null);
      try {
        await loadTemplateById(id, (data) => {
          if (data instanceof Error) {
            throw data;
          } else {
            setCurrentTemplate(data);
          }
        });
      } catch (ex) {
        if (ex.response?.status === 401 || ex.response?.status === 403) {
          navigate("/");
        } else {
          createErrorFeedback(
            uiFeedbackDispatch,
            intl.formatMessage({
              id: "page.edittemplate.exception.update.title",
            }),
            intl.formatMessage({
              id: "page.edittemplate.exception.update.description",
            }),
          );
        }
      } finally {
        closeWaiting(uiFeedbackDispatch);
      }
    };

    const checkNotEmpy = (items) => {
      return items.filter((item) => item === null).length === 0;
    };

    if (
      (reload || localTemplateId.current !== id) &&
      checkNotEmpy([loadTemplateById, intl, navigate, uiFeedbackDispatch])
    ) {
      setReload(false);
      localTemplateId.current = id;
      loadTemplate();
    }
  }, [
    id,
    reload,
    localTemplateId,
    loadTemplateById,
    intl,
    navigate,
    uiFeedbackDispatch,
  ]);

  const buildPaths = () => {
    return [
      {
        link: "/",
        title: intl.formatMessage({ id: "page.welcome.title" }),
      },
      {
        link: "/templates",
        title: intl.formatMessage({ id: "page.templates.title" }),
      },
    ];
  };

  if (!currentTemplate) {
    return null;
  }

  return (
    <PageLayout paths={buildPaths()} title={currentTemplate.name}>
      <TemplateEditor
        currentTemplate={currentTemplate}
        onSuccess={(updatedTemplate) => {
          setReload(true);
        }}
      />
    </PageLayout>
  );
};
